/* eslint-disable */


const NAV = window.navigator;

const PluginDetector = {
   plugins: [],

   hasPluginVersion: (plugin, v) => {
      const pv = PluginDetector.plugins[plugin];
      v[1] = v[1] || 0;
      v[2] = v[2] || 0;
      return (pv[0] > v[0] || (pv[0] === v[0] && pv[1] > v[1]) || (pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2]));
   },

   addPlugin: (p, pluginName, mimeType, activeX, axDetect) => {
      PluginDetector.plugins[p] = PluginDetector.detectPlugin(pluginName, mimeType, activeX, axDetect);
   },

   detectPlugin: (pluginName, mimeType, activeX, axDetect) => {

      let
         version = [0, 0, 0],
         description,
         ax
         ;

      // Firefox, Webkit, Opera; avoid MS Edge since `plugins` cannot be accessed
      if (NAV.plugins !== null && NAV.plugins !== undefined && typeof NAV.plugins[pluginName] === 'object') {
         description = NAV.plugins[pluginName].description;
         if (description && !(typeof NAV.mimeTypes !== 'undefined' && NAV.mimeTypes[mimeType] && !NAV.mimeTypes[mimeType].enabledPlugin)) {
            version = description.replace(pluginName, '').replace(/^\s+/, '').replace(/\sr/gi, '.').split('.');
            for (let i = 0, total = version.length; i < total; i++) {
               version[i] = parseInt(version[i].match(/\d+/), 10);
            }
         }
         // Internet Explorer / ActiveX
      } else if (window.ActiveXObject !== undefined) {
         try {
            ax = new ActiveXObject(activeX);
            if (ax) {
               version = axDetect(ax);
            }
         } catch (e) {
            console.log(e);
         }
      }
      return version;
   }
};

PluginDetector.addPlugin('flash', 'Shockwave Flash', 'application/x-shockwave-flash', 'ShockwaveFlash.ShockwaveFlash', (ax) => {
   // adapted from SWFObject
   let
      version = [],
      d = ax.GetVariable("$version")
      ;

   if (d) {
      d = d.split(" ")[1].split(",");
      version = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
   }
   return version;
});

export default PluginDetector.hasPluginVersion('flash', [10, 0, 0]);
